export default {
    breadcrumbs: {
        network: 'Network',
        request_appointment_at_invite: 'Send a reminder',
    },

    titles: {
        request_appointment_at_invite: 'Remind {user} to join MedMatch',
    },
    request_sent: 'Request sent!',
}
